var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.1 17.767 2.9-3.9s4.1-2.3 3.4-4c-.1-.3-.9-.6-1.6-.1-.6.4-2.8 1.9-3.7 2.7-.9.7-4.1 3.7-4.1 3.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2 15.467c5.357 0 9.7 2.776 9.7 6.2s-4.343 6.2-9.7 6.2-9.7-2.776-9.7-6.2 4.343-6.2 9.7-6.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 23.767c0-3.1 4-5.5 8.9-5.5s8.9 2.5 8.9 5.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.7 21.868v1.699c0 3.4 4.3 6.7 9.7 6.7s9.6-3.3 9.6-6.8v-1.7M31.8 10.168l-.3.3c-.3.2-.6.1-.7 0"
}))));
export default SvgStove;